import { render } from "./SprintTable.vue?vue&type=template&id=fcf67ace&scoped=true"
import script from "./SprintTable.vue?vue&type=script&lang=js"
export * from "./SprintTable.vue?vue&type=script&lang=js"

import "./SprintTable.vue?vue&type=style&index=0&id=fcf67ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf67ace"]])

export default __exports__